import { render } from "./ClientProjects.vue?vue&type=template&id=8492c13e&scoped=true"
import script from "./ClientProjects.vue?vue&type=script&lang=js"
export * from "./ClientProjects.vue?vue&type=script&lang=js"

import "./ClientProjects.vue?vue&type=style&index=0&id=8492c13e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8492c13e"]])

export default __exports__